import { Pipe, PipeTransform } from "@angular/core";
import { MBTI } from "../interfaces/mbti";

@Pipe({
  name: 'mbtiImage'
})
export class MbtiImagePipe implements PipeTransform {
  transform(value: MBTI | undefined) {
    if (value === undefined) {
      return '';
    }
    return `assets/icons/mbti/${value.toUpperCase()}.png`;
  }
}